import { Button } from '../../buttons/Button';
import { Plus } from 'lucide-react';
import { useDataManagementContext } from '../../../hooks/useDataManagementContext';
import { useErrorHandling } from '../../../utils/useErrorHandling';

export function DataManagementHeader() {
  const context = useDataManagementContext();
  const { showContextError } = useErrorHandling();
  
  if (!context) {
    showContextError('DataManagementHeader');
    return null;
  }

  const { title, permissions, onSelectItem, onOpenChange } = context;
  
  const canCreate = permissions.verbs?.create;
  
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-2xl font-bold">{title}</h1>
      {canCreate && (
        <Button 
          onClick={() => {
            onSelectItem(null);
            onOpenChange(true);
          }}
        >
          <Plus className="mr-2 h-4 w-4" />
          Add {title.slice(0, -1)}
        </Button>
      )}
    </div>
  );
} 